/**
 * @type {import("@mui/material").Theme}
 */
const lightThemePalette = {
  palette: {
    mode: 'light',
    background: {
      paper: '#FFF',
      default: '#F6F8F8',
      card: '#FFF',
    },
    primary: {
      main: '#B9D300',
      light: '#d6e753',
      dark: '#c9df20',
      contrastText: '#FFF',
    },
    // divider: '#f3f4f5',
    secondary: {
      main: '#6D28D8',
      light: '#d6e753',
      dark: '#c9df20',
      contrastText: '#FFF',
    },
    text: {
      primary: '#212121',
      secondary: '#666666',
      disabled: '#797F8D',
      dark: '#17191C',
    },
    common: {
      service: {
        pending: '#FFB800',
        active: '#00CF82',
        deactive: '#E52929',
      },
    },
  },
  cardBg: {
    main: '#FFF',
    lightGray: '#F8F9F9',
  },
  clubIcon: {
    light: '#BBB7B7',
    inCall: '#00CF82',
    outCall: '#E52929',
    headerIcon: '#BFC5D2',
    download: '#00CF82',
    upload: '#2E5BFF',
    ping: '#FF2E66',
    join: '#00CF82',
  },
  brand: {
    main: '#B9D300',
  },
  asideMenu: {
    unselectedIcon: '#BFC5D2',
    selectedIcon: '#B9D300',
    unselectedText: '#797F8D',
    selectedText: '#B9D300',
  },
  cardBackGround: {
    lightGray: '#F8F9F9',
    lightMain: 'rgba(185, 211, 0, 0.1)',
    darkGray: '#F8F9F9',
  },
  service: {
    pending: '#FFB800',
    active: '#00CF82',
    deactive: '#E52929',
  },
  invoice: {
    main: '#f8f8f8',
    payment: '#fff',
    divider: '#f3f4f5',
    border: '#d6deee',
  },
  modal: { main: '#FFF' },
  bonous: {
    border: '#F8F9F9',
  },
  support: {
    border: '#EEEEEE',
  },
};

export default lightThemePalette;
